"use client"
import Footer from '@/components/widgets/footer/Footer'
import SimpleComponent from '@/components/widgets/SimpleComponent'
import React from 'react'
import HeroSection from './engagement-page-widgets/HeroSection'

const Engagement = () => {
  return (
    <SimpleComponent>
        <HeroSection/>
        <Footer/>
    </SimpleComponent>
  )
}

export default Engagement